import React from 'react';

import IntegrationsPageContent from 'components/dashboard/integrations/IntegrationsPageContent';

const DashboardIntegrationsPage = () => <IntegrationsPageContent integration="shopify" />;

export default DashboardIntegrationsPage;
